import {updateIncidentForVerification} from "../../../api/maintenance/IncidentService";
import {updateInspectionForVerification} from "../../../api/maintenance/InspectionService";
import {updateWorkForVerification} from "../../../api/maintenance/WorkService";
import {updateIntroductionForVerification} from "../../../api/lifecycle/introduction/IntroductionService";
import {updateDisposeForVerification} from "../../../api/lifecycle/dispose/DisposeService";
import {
    updateServiceRequestForVerification,
    updateVerificationDone,
} from "../../../api/serviceRequest/ServiceRequestService";
import {ContentCategory} from "../../../constant/CodeSpecNum";

export const MAINTENANCE_VERIFICATION_VARIANTS = {
    inspection: {
        contentCategory: ContentCategory.INSPECTION,
        linkedContentCategory: ContentCategory.INSPECTION_POST_APPROVE,
        reworkType: "INSPECTION",
        endDateField: "inspectEndDate",
        endDateLabel: "마감일 조정",
        useTime: false,
        completeOrder: "statusFirst",
        updateVerification: updateInspectionForVerification,
    },
    incident: {
        contentCategory: ContentCategory.INCIDENT,
        linkedContentCategory: ContentCategory.INCIDENT_POST_APPROVE,
        reworkType: "INCIDENT",
        endDateField: "incidentEndDate",
        endDateLabel: "마감일 조정",
        useTime: true,
        completeOrder: "statusFirst",
        updateVerification: updateIncidentForVerification,
    },
    work: {
        contentCategory: ContentCategory.WORK,
        linkedContentCategory: ContentCategory.WORK_POST_APPROVE,
        reworkType: "WORK",
        endDateField: "workEndDate",
        endDateLabel: "마감일 조정",
        useTime: true,
        completeOrder: "statusFirst",
        updateVerification: updateWorkForVerification,
    },
    introduction: {
        contentCategory: ContentCategory.INTRODUCTION,
        useTime: false,
        completeOrder: "statusFirst",
        updateVerification: updateIntroductionForVerification,
        getAuthUpdate: (data) => data.auth?.update,
        hideRework: true,
        hideEndDateAdjustment: true,
    },
    dispose: {
        contentCategory: ContentCategory.DISPOSE,
        useTime: false,
        completeOrder: "statusFirst",
        updateVerification: updateDisposeForVerification,
        getAuthUpdate: (data) => data.auth?.update,
        hideRework: true,
        hideEndDateAdjustment: true,
    },
    serviceRequest: {
        contentCategory: ContentCategory.SERVICE_REQUEST,
        reworkType: "SERVICE_REQUEST",
        endDateLabel: "요청마감일 조정",
        useTime: false,
        completeOrder: "verificationFirst",
        includeRequestCloseDates: true,
        showVerifierInReadOnly: true,
        updateVerification: updateServiceRequestForVerification,
        completeVerification: updateVerificationDone,
        getContentId: (data) => data.serviceRequestId ?? data.id,
        getAuthUpdate: (data) => data.rudAuthDto?.update,
        resolveEndDateField: (data) =>
            data.adjustedRequestCloseDate ? "adjustedRequestCloseDate" : "requestCloseDate",
        getEndDateConstraint: (data) => data.adjustedRequestCloseDate ?? data.requestCloseDate,
        getReworkCloseDates: (data, verification) => ({
            beforeCloseDate: data.adjustedRequestCloseDate ?? data.requestCloseDate,
            afterCloseDate: data.adjustedRequestCloseDate
                ? verification.adjustedRequestCloseDate
                : verification.requestCloseDate,
        }),
    },
};

export function getMaintenanceVerificationConfig(variant) {
    return MAINTENANCE_VERIFICATION_VARIANTS[variant] ?? MAINTENANCE_VERIFICATION_VARIANTS.inspection;
}

export function resolveVerificationEndDateField(data, config) {
    return config.resolveEndDateField?.(data) ?? config.endDateField;
}

export function resolveVerificationContentId(data, config) {
    return config.getContentId?.(data) ?? data.id;
}
